export function timer(func, time, scope ){
    var a =  Array.prototype.slice.call(arguments, 3); //remove the func, time, scope from arguments list
    setTimeout(function(){
        func.apply(scope || this, a);
    }, time);
}